import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const TAttendanceApi = createApi({
  reducerPath: 'TAttendanceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}`,
  }),
  endpoints: (builder) => ({
    getAllTAttendance: builder.mutation({
      query: ({ ep, token }) => {

        return {
          url: ep,
          method: 'POST',
          redirect: 'follow',
          body: JSON.parse(JSON.stringify({ origin: `${process.env.REACT_APP_ADMIN_APP}` })),
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': `${process.env.REACT_APP_ADMIN_APP}`,
            'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
            'Access-Control-Allow-Headers':
              'Access-Control-Allow-Headers, Access-Control-Allow-Methods, Access-Control-Allow-Origin, Access-Control-Allow-Credentials, Origin, X-Requested-With, Content-Type, Accept, Authorization, access-control-allow-credentials,access-control-allow-headers,access-control-allow-methods,access-control-allow-origin,content-type',
            'Access-Control-Allow-Credentials': 'true',
          },
        };
      },
      transformResponse: (response) => response,
    }),
    postTAttendance: builder.mutation({
      query: ({ ep, values, token }) => {

        return {
          url: ep,
          method: 'POST',
          redirect: 'follow',
          body: JSON.parse(
            JSON.stringify({ ...values, origin: `${process.env.REACT_APP_ADMIN_APP}` })
          ),
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': `${process.env.REACT_APP_ADMIN_APP}`,
            'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
            'Access-Control-Allow-Headers':
              'Access-Control-Allow-Headers, Access-Control-Allow-Methods, Access-Control-Allow-Origin, Access-Control-Allow-Credentials, Origin, X-Requested-With, Content-Type, Accept, Authorization, access-control-allow-credentials,access-control-allow-headers,access-control-allow-methods,access-control-allow-origin,content-type',
            'Access-Control-Allow-Credentials': 'true',
          },
        };
      },
    }),
    postEditTAttendance: builder.mutation({
      query: ({ ep, values, token }) => {

        return {
          url: ep,
          method: 'POST',
          redirect: 'follow',
          body: JSON.parse(
            JSON.stringify({ ...values, origin: `${process.env.REACT_APP_ADMIN_APP}` })
          ),
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': `${process.env.REACT_APP_ADMIN_APP}`,
            'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
            'Access-Control-Allow-Headers':
              'Access-Control-Allow-Headers, Access-Control-Allow-Methods, Access-Control-Allow-Origin, Access-Control-Allow-Credentials, Origin, X-Requested-With, Content-Type, Accept, Authorization, access-control-allow-credentials,access-control-allow-headers,access-control-allow-methods,access-control-allow-origin,content-type',
            'Access-Control-Allow-Credentials': 'true',
          },
        };
      },
    }),
  }),
});

export const {
  useGetAllTAttendanceMutation,
  usePostTAttendanceMutation,
  usePostEditTAttendanceMutation,
} = TAttendanceApi;

export const { TAttendanceApiReducer } = TAttendanceApi.reducer;
